import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import EmailTabs from '../../components/tabs/email/EmailTabs';
import PageHeader from '../../components/ui/PageHeader';
import { HOME_CRUMB } from '../../components/ui/Breadcrumbs';

const Email: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [initialTab, setInitialTab] = useState<string | null>(null);

  useEffect(() => {
    const tabParam = searchParams.get('tab');
    if (tabParam) {
      setInitialTab(tabParam);
    }
  }, [searchParams]);

  return (
    // Same container as the other revamped pages; the shell supplies the
    // neutral page background.
    <div className="dashboard-container py-2 sm:p-6">
      <PageHeader
        breadcrumbs={[HOME_CRUMB, { label: "Email" }]}
        className="mb-6"
        title="Email"
        description="Templates and pitch bodies used when you email a pitch."
      />

      {/* Tabs */}
      <EmailTabs
        initialTab={initialTab}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
      />
    </div>
  );
};

export default Email;
